export enum VerifySectionType {
  IdScan,
  PhotoId,
  POA,
  POP,
  SOWQ,
  SupportingDocuments,
  SOF,
}
